module.exports = __webpack_public_path__ + "media/images/mobile-only/el-3-430a20d6ed75a458a718e089867bd67a.png";